<template>
	<div class="machine-renewal">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('myApps.myAppsTitle')"
			:visible.sync="dialogBuyPannel"
			width="40%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<!-- 购买内容开始 -->
			<template>
				<!-- 购买信息 -->
				<div v-if="stepsActive === 0" class="content" v-loading="loading">
					<div class="title">
						<div class="el-alert--info renew-info">
							<div>
								<p>{{ $t("userRecharge.hello") }}！{{ nickName }}</p>
								<div class="renew-text">
									{{ $t("myApps.renewL")
									}}<span style="font-weight: bold">{{
										$t("myApps.myAppsTitle")
									}}</span
									>{{ $t("myApps.please") }}
								</div>
							</div>
							<div class="renew-tip">
								<div class="renew-price">
									{{ $t("myApps.buyapp") }}{{ iteminfo.title }}
								</div>
							</div>
							<div class="renew-tip" style="margin-top: 0">
								<div class="renew-price">
									{{ $t("myApps.buyprice") }}($){{ iteminfo.price }}
								</div>
							</div>
						</div>
					</div>
					<div class="tip">
						<el-alert
							:title="$t('userRecharge.note2')"
							:description="$t('myApps.tips2')"
							type="warning"
							:closable="false">
						</el-alert>
					</div>
				</div>

				<!-- 支付方式 -->
				<div
					v-if="stepsActive === 1"
					class="content"
					v-loading="fullscreenLoading">
					<!-- 支付方式选择TAB -->
					<div style="width: 100%; display: flex; text-align: center">
						<div
							:class="payActive == 1 ? 'tablock active' : 'tablock'"
							@click="handlePayTab(1)"
							style="width: 50%; margin-right: 20px">
							{{ $t("userRecharge.step21") }}
						</div>
						<div
							:class="payActive == 3 ? 'tablock active' : 'tablock'"
							@click="handlePayTab(3)"
							style="width: 50%">
							{{ $t("userRecharge.huikuan") }}
						</div>
					</div>
					<el-row v-if="payActive == 1" style="margin-top: 20px">
						<el-col span="24" style="text-align: center">
							<div v-if="qrCode" class="paypal">
								<div class="title">{{ $t("myWallet.paypaltip") }}</div>
								<img :src="'data:image/png;base64,' + qrCode" style="" />
								<a
									:href="hrefurl"
									target="_blank"
									style="text-decoration: underline; color: var(--vtm-mint-ink)"
									><div style="line-height: 50px">
										{{ $t("common.dianwo") }}
									</div></a
								>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="payActive == 3" style="margin-top: 20px">
						<div class="card-info">
							<div class="title">
								{{ $t("userRecharge.information") }}
							</div>
							<div class="info">
								<el-row :gutter="20">
									<el-col :span="12">
										Account No: {{ payConfig.accountNo }}
									</el-col>
									<el-col :span="12"> Name: {{ payConfig.name }} </el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										Beneficiary Bank Name: {{ payConfig.beneficiaryBankName }}
									</el-col>
									<el-col :span="12">
										Beneficiary Bank Address:
										{{ payConfig.beneficiaryBankAddress }}
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										Beneficiary Bank code: {{ payConfig.beneficiaryBankCode }}
									</el-col>
									<el-col :span="12">
										SWIFT: {{ payConfig.swiftAddress }}
									</el-col>
								</el-row>
							</div>
						</div>
						<div class="renew-upload">
							<el-row :gutter="20">
								<el-col :span="12">
									<el-upload
										class="upload-demo"
										drag
										ref="upload"
										:action="uploadUrl"
										:headers="headers"
										accept=".jpg,.png"
										:limit="limit"
										:on-success="handleSuccess"
										:before-upload="beforeUpload"
										:on-remove="handleRemove"
										:on-error="handleError">
										<i class="el-icon-upload"></i>
										<div class="el-upload__text">
											{{ $t("userRecharge.text")
											}}<em>{{ $t("userRecharge.sub") }}</em>
										</div>
										<!--<div class="el-upload__tip" slot="tip">{{$t('userRecharge.tip')}}</div>-->
									</el-upload>
								</el-col>
								<el-col :span="12">
									<div class="renew-img">
										<span v-if="!image">{{ $t("userRecharge.receipt") }}</span>
										<el-image
											v-else
											style="width: 100px; height: 100px"
											:src="image"
											fit="contain"></el-image>
									</div>
								</el-col>
								<el-col :span="24">
									<el-alert
										style="margin-top: 5px"
										:description="$t('userRecharge.tip')"
										type="warning"
										:closable="false">
									</el-alert>
								</el-col>
							</el-row>
						</div>
						<div class="tip">
							<el-alert
								:title="$t('userRecharge.note2')"
								:description="$t('userRecharge.description')"
								type="warning"
								:closable="false">
							</el-alert>
						</div>
					</el-row>
				</div>

				<!-- 充值结果 -->
				<div v-if="stepsActive === 2" class="content">
					<div class="renew-result">
						<div :class="['result', result]"></div>
						<div class="result-text">
							<div class="title">{{ resultText }}</div>
							<div class="content">
								{{ rechargeContent() }}
							</div>
						</div>
					</div>
					<div class="tip">
						<el-alert
							:title="$t('userRecharge.note2')"
							:description="$t('myApps.tips2')"
							type="warning"
							:closable="false">
						</el-alert>
					</div>
				</div>
			</template>
			<!-- 充值内容结束 -->

			<!-- 底部导航开始 -->
			<template>
				<!-- 购买信息 -->
				<div v-if="stepsActive === 0" slot="footer" class="dialog-footer">
					<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
					<el-button type="primary" @click="submitForm()">{{
						$t("renewalRecord.do")
					}}</el-button>
				</div>

				<!-- 支付方式 -->
				<div v-if="stepsActive === 1" slot="footer" class="dialog-footer">
					<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
					<el-button type="primary" @click="submitForm()">{{
						$t("renewalRecord.next")
					}}</el-button>
				</div>

				<!-- 充值结果 -->
				<div v-if="stepsActive === 2" slot="footer" class="dialog-footer">
					<el-button type="primary" @click="submitForm()">{{
						$t("common.finnial")
					}}</el-button>
				</div>
			</template>
			<!-- 底部导航结束 -->
		</el-dialog>
	</div>
</template>

<script>
import config from "@/http/config";
let daojishi = "";
export default {
	name: "BuyPannel",
	props: {
		dialogBuyPannel: Boolean,
		iteminfo: {
			type: Object,
		},
		confirmRenew: Object,
		stepsActive: {
			type: Number,
			default: 0,
		},
		orderNumber: {
			type: String,
			default: "",
		},
		result: {
			type: String,
			default: "el-icon-info",
		},
		resultText: {
			type: String,
			default: "",
		},
		process: {
			type: String,
			default: "process",
		},
		state: {
			type: String,
			default: "0",
		},
	},
	data() {
		return {
			loading: false,
			fullscreenLoading: false,
			payActive: 1,
			qrCode: "",
			hrefurl: "",
			payOrderNo: "",
			payConfig: {},
			uploadUrl: config.baseUrl + this.$url.Upload.renew,
			headers: {
				token: this.$cookies.get("token"),
			},
			image: "",
			limit: 1,
		};
	},
	methods: {
		// 弹窗打开触发
		openDialog() {
			this.rentState();
			if (this.stepsActive == 1 && this.payActive == 1) {
				this.fullscreenLoading = true;
			} else {
				this.loading = true;
			}
			// 获取线下汇款信息
			this.$api
				.request(this.$url.RechargeRecord.getPayConfig, this.$method.get)
				.then(res => {
					if (res.code === 0) {
						this.payConfig = res.data;
						// 查看详情
						if (this.stepsActive == 1 && this.payActive == 1) {
							// 获取PayPal后台充值二维码
							this.$api
								.request(
									this.$url.RechargeRecord.rechargePAYPAL,
									this.$method.get,
									{
										orderId: this.orderNumber,
										orderType: "WALLET_RECHARGE_ORDER",
									}
								)
								.then(res => {
									if (res.code === 0) {
										this.hrefurl = res.data.href;
										this.qrCode = res.data.url;
										this.payOrderNo = res.data.orderNumber;
										this.fullscreenLoading = false;
										// 开启监听订单支付状态
										this.listenOrder();
									}
								});
						} else {
							this.loading = false;
						}
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 弹窗关闭触发
		closeDialog() {
			this.cancel(this.stepsActive > 0 ? "up" : "");
			this.stepsActive = 0;
		},
		/* 支付方式切换 */
		handlePayTab(index) {
			this.payActive = parseInt(index);
			if (parseInt(index) == 1) {
				// 开启监听订单支付状态
				this.listenOrder();
			}
		},
		// 弹窗取消触发
		cancel(state) {
			if (daojishi) {
				clearTimeout(daojishi);
			}
			this.$emit("cancelBuyPannel", false, state);
		},
		// 下一步、已付款、上传回执触发
		submitForm() {
			if (this.stepsActive === 0) {
				this.loading = true;
				// 下一步：生成充值订单后切换至支付方式
				this.stepsActive = parseInt(this.stepsActive) + 1;
			} else if (this.stepsActive === 1) {
				// 下一步：购买结果
				this.stepsActive = parseInt(this.stepsActive + 1);
			} else if (this.stepsActive === 2) {
				// 购买结果确认已完成
				this.$emit("cancelBuyPannel", false, "");
			}
		},
		// 检测订单付款状态
		listenOrder() {
			if (parseInt(this.payActive) != 1) {
				return false;
			}
			this.$api
				.request(this.$url.RechargeRecord.getByOrderNo, this.$method.get, {
					orderNumber: this.payOrderNo,
				})
				.then(res => {
					if (res.code === 0) {
						if (res.data) {
							let state = res.data.payStatus;
							if (parseInt(state) > 0) {
								// 切换至充值结果
								if (parseInt(state) == 1) {
									// 已完成付款，充值核实中
									this.stepsActive = parseInt(this.stepsActive) + 1;
									this.state = "1";
									this.result = "el-icon-info";
									this.resultText = this.$t("userRecharge.wait");
								} else if (parseInt(state) == 2) {
									// 已完成付款，充值已完成
									this.stepsActive = parseInt(this.stepsActive) + 1;
									this.state = "2";
									this.result = "el-icon-info";
									this.resultText = this.$t("userRecharge.success");
								} else if (parseInt(state) == 0) {
									// 申请充值中
									this.$message.warning(this.$t("common.qxwcpay"));
								}
							} else {
								daojishi = setTimeout(() => {
									clearTimeout(daojishi);
									this.listenOrder();
								}, 1500);
							}
						} else {
							daojishi = setTimeout(() => {
								clearTimeout(daojishi);
								this.listenOrder();
							}, 1500);
						}
					} else {
						daojishi = setTimeout(() => {
							clearTimeout(daojishi);
							this.listenOrder();
						}, 1500);
					}
				});
		},
		// 文件上传成功钩子
		handleSuccess(res) {
			if (res.code === 0) {
				this.image = res.data;
			} else {
				this.$message.error(this.$t("userRecharge.receiptFail"));
				this.$refs.upload.clearFiles();
			}
		},
		// 文件上传前触发
		beforeUpload(file) {
			console.log(file);
			const isJPG =
				file.type === "image/jpeg" ||
				file.type === "image/jpg" ||
				file.type === "image/png";
			const isLt2M = file.size / 1024 / 1024 < 1;

			if (!isJPG) {
				this.$message.error(this.$t("userRecharge.imgType"));
			}
			if (!isLt2M) {
				this.$message.error(this.$t("userRecharge.imgSize") + "1M");
			}
			return isJPG && isLt2M;
		},
		// 文件移除触发
		handleRemove() {
			this.image = "";
		},
		// 文件上传错误触发
		handleError(err) {
			this.$message.error(err.msg ? err.msg : this.$t("userRecharge.error"));
		},
		// 获取充值状态
		rentState() {
			if (this.state === "1" || this.state === 1) {
				this.result = "el-icon-info";
				this.resultText = this.$t("userRecharge.wait");
			} else if (this.state === "2" || this.state === 2) {
				this.result = "el-icon-success";
				this.resultText = this.$t("userRecharge.success");
			} else if (this.state === "3" || this.state === 3) {
				this.result = "el-icon-error";
				this.resultText = this.$t("userRecharge.fail");
			} else {
				this.result = "el-icon-error";
				this.resultText = this.$t("userRecharge.expired");
			}
		},
		// 获取充值结果信息
		rechargeContent() {
			if (this.state == "1") {
				return this.$t("userRecharge.content");
			} else if (this.status == "2") {
				return this.$t("userRecharge.content2");
			} else if (this.status == "3") {
				return this.confirmRenew.failure;
			} else {
				return this.$t("userRecharge.content3");
			}
		},
	},
};
</script>

<style lang="scss">
@import "~@/assets/renew/iconfont.css";
.el-dialog__body {
	height: auto !important;
}
.machine-renewal .title {
	margin-bottom: 20px;
}
.machine-renewal {
	.el-alert {
		color: var(--vtm-ink-2);
		.el-alert__description {
			color: var(--vtm-ink-2);
		}
	}
	.renew-info {
		padding: 10px;
		border-radius: 4px;
		overflow: hidden;
	}
	.el-alert--info {
		border: 1px solid var(--vtm-info);
		background-color: var(--vtm-info-soft);
	}
	.el-alert--success {
		border: 1px solid var(--vtm-ok);
		background-color: var(--vtm-ok-soft);
	}
	.el-alert--warning {
		border: 1px solid var(--vtm-warn);
		background-color: var(--vtm-warn-soft);
	}
	.renew-text {
		text-indent: 20px;
		margin: 8px 0;
	}
	.renew-num {
		margin: 0 5px;
		font-size: 16px;
		font-weight: bold;
		color: var(--vtm-mint-ink);
	}
}
.machine-renewal .price {
	font-weight: 500;
	font-size: 28px;
	color: var(--vtm-crit);
	margin-bottom: 5px;
}
.machine-renewal .grid-content {
	padding: 20px;
	position: relative;
	.renew {
		text-align: center;
		border-radius: 8px;
		border: 1px solid var(--vtm-line);
		padding: 20px;
		cursor: pointer;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
		.iconfont {
			font-size: 65px;
			color: var(--vtm-ink-3);
			display: block;
			margin-bottom: 10px;
		}
	}
	.renew:hover {
		transform: translateY(-10px);
		border: 1px solid var(--vtm-mint);
	}
	.active {
		border: 1px solid var(--vtm-mint);
		.iconfont {
			color: var(--vtm-mint-ink);
		}
	}
	.renew-time {
		font-size: 14px;
		margin-bottom: 20px;
		color: var(--vtm-ink);
	}
	.line {
		position: relative;
	}
	.line:before {
		content: "";
		width: 100%;
		height: 1px;
		background-color: var(--vtm-line-2);
		/*如果不使用background-color，也可以使用border-top: 1px solid #F00;*/
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		position: absolute;
		right: 0;
		bottom: 0;
		left: 0;
		-webkit-transform: scaleY(0.5);
		-moz-transform: scaleY(0.5);
		transform: scaleY(0.5);
	}
	.content {
		padding-top: 20px;
	}
}
.machine-renewal .tip {
	margin-top: 10px;
}
.machine-renewal .top {
	position: absolute;
	background: var(--vtm-mint);
	color: var(--vtm-navy);
	height: 50px;
	line-height: 70px;
	width: 150px;
	text-align: center;
	top: -15px;
	right: -65px;
	transform: rotate(45deg);
}
.machine-renewal .card-info {
	padding: 20px;
	border: 1px solid var(--vtm-info);
	background-color: var(--vtm-info-soft);
	border-radius: 4px;
	position: relative;
	.title {
		text-align: center;
		font-weight: 500;
		font-size: 22px;
		margin-bottom: 25px;
	}
	.el-row {
		margin: 15px 0;
	}
}
.machine-renewal .renew-tip {
	display: flex;
	justify-content: space-between;
	font-weight: bold;
}
.machine-renewal .renew-price {
	font-size: 16px;
	color: var(--vtm-crit);
}
.machine-renewal .el-steps {
	margin-bottom: 20px;
}
.machine-renewal .renew-upload {
	margin-top: 20px;
}
.machine-renewal .renew-img {
	width: 100%;
	height: 178px;
	border: 1px dashed var(--vtm-line);
	border-radius: 6px;
	line-height: 180px;
	text-align: center;
	font-size: 20px;
	.el-image {
		margin-top: 40px;
	}
}
.machine-renewal .el-upload-dragger {
	width: 100%;
}
.machine-renewal .el-upload {
	width: 100%;
}
.machine-renewal .result {
	margin: 50px auto 30px;
	text-align: center;
	display: block;
	font-size: 120px;
}
.machine-renewal .el-icon-info {
	color: var(--vtm-mint-ink);
}
.machine-renewal .el-icon-success {
	color: var(--vtm-ok);
}
.machine-renewal .el-icon-error {
	color: var(--vtm-crit);
}
.machine-renewal .renew-result {
	padding: 0 100px;
	text-align: center;
	font-size: 16px;
	.result-text .title {
		font-size: 24px;
		color: var(--vtm-ink);
	}
	.content {
		color: var(--vtm-ink-3);
	}
}
.el-dialog__body {
	padding: 20px;
}
.el-dialog__footer {
	padding: 0 20px 20px 20px;
}
.tablock {
	width: 55%;
	height: 40px;
	line-height: 40px;
	margin: 0 auto;
	font-size: 16px;
	cursor: pointer;
	border-radius: 5px;
	border: 1px solid var(--vtm-line);
}
.active {
	background-color: var(--vtm-mint);
	border: 1px solid var(--vtm-mint);
	color: var(--vtm-navy);
}
.paypal {
	width: 99.5%;
	border-radius: 5px;
	border: 1px solid var(--vtm-mint);
	background-color: var(--vtm-mint-soft);
	margin: 0 auto;
}
.paypal .title {
	text-align: center;
	line-height: 0.8rem;
	margin-bottom: 0;
}
.paypal img {
	width: 2rem;
	height: 2rem;
	margin: 0 auto;
	display: block;
}
.huikuan {
	width: 99%;
	padding-bottom: 0.1rem;
	margin: 0 auto;
	border-radius: 5px;
	border: 1px solid var(--vtm-mint);
	background-color: var(--vtm-mint-soft);
	margin-top: 10px;
}
.huikuan .title {
	text-align: center;
	line-height: 0.5rem;
	font-size: 16px;
}
.huikuan .content {
	padding: 0 3%;
}
.huikuan .content .el-row {
	margin-bottom: 0.1rem;
}
.tishi {
	width: 99%;
	margin: 0 auto;
	border-radius: 5px;
	border: 1px solid var(--vtm-warn);
	background-color: var(--vtm-warn-soft);
	margin-top: 3%;
}
.tishi .content {
	padding: 2% 3%;
}
.upload {
	width: 100%;
	margin-top: 3%;
}
.upload .upload-demo {
	width: 100%;
}
.upload .el-upload {
	width: 100%;
}
.upload .el-upload-dragger {
	width: 100%;
}
</style>
